export const RTKSteps = {
  itemSelect: 'itemSelect',
  billing: 'billing',
  review: 'review',
  confirmation: 'confirmation',
}
